import { TeamType as ApiTeamType } from 'src/api/generated/touring/types';
import { TeamType } from './types';

export const mapTeamType = (team: ApiTeamType): TeamType => {
  return {
    id: team.id,
    name: team.name,
  };
};
